<template>
	<div class="navigation container">
	  <b-nav class="float-right">
	    <b-nav-item to="/">Home</b-nav-item>
	    <b-nav-item to="/projects">Projects</b-nav-item>
	    <b-nav-item to="/articles">Articles</b-nav-item>
	  </b-nav>
	</div>
</template>

<script>
	export default {
		name: 'Navigation'
	}
</script>


// WEBPACK FOOTER //
// src/Components/Navigation.vue